<template>
    <div>
        <b-card-actions action-collapse title="House Price">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <b-form-group>
                            <label class="owner-label">
                                Selling Price / {{ formatSaleNumber() }} per sqw.
                            </label>
                            <b-form-input
                                v-model.number="form.sale_price"
                                placeholder="Sale Price"
                                type="number"
                                min="0"
                                @input="onSalePriceInput"
                            />
                            <small v-if="saleError" class="text-danger">
                                {{ saleErrorMessage }}
                            </small>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label class="owner-label">
                                Rent Price / {{ formatRentNumber() }} per sqw.
                            </label>
                            <b-form-input
                                v-model.number="form.rent_price"
                                placeholder="Rent Price"
                                type="number"
                                min="0"
                                @input="validateRentPrice"
                            />
                            <small v-if="rentError" class="text-danger">
                                {{ rentErrorMessage }}
                            </small>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-actions>
    </div>
</template>

<script>
import {
    BRow, BCol, BFormGroup, BForm, BFormInput,
} from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import router from '@/router'

export default {
    components: {
        BCardActions, BRow, BCol, BFormGroup, BForm, BFormInput,
    },
    props: {
        form: { type: Object, required: true }
    },
    data() {
        return {
            priceRent: 0,
            priceSale: 0,
            priceRentSqm: 0,
            priceSaleSqm: 0,
            sqm: 0,
            saleError: false,
            saleErrorMessage: '',
            rentError: false,
            rentErrorMessage: ''
        }
    },
    methods: {
        onSalePriceInput() {
            this.updatePricePerSqm()
            this.validateSalePrice()
            if (this.form.rent_price) this.validateRentPrice()
        },
        validateSalePrice() {
            this.saleError = false
            this.saleErrorMessage = ''

            const price = Number(this.form.sale_price)
            if (this.form.sale_price !== '' && this.form.sale_price !== null) {
                if (price < 0) {
                    this.saleError = true
                    this.saleErrorMessage = 'Sale price cannot be negative'
                }
            }
        },
        validateRentPrice() {
            this.rentError = false
            this.rentErrorMessage = ''

            const rent = Number(this.form.rent_price)
            const sale = Number(this.form.sale_price)

            if (this.form.rent_price !== '' && this.form.rent_price !== null) {
                if (rent < 0) {
                    this.rentError = true
                    this.rentErrorMessage = 'Rent price cannot be negative'
                    return
                }
                if (rent > 1500000) {
                    this.rentError = true
                    this.rentErrorMessage = 'Rent price cannot be more than 1,500,000'
                    return
                }
                if (this.form.sale_price && rent > sale) {
                    this.rentError = true
                    this.rentErrorMessage = 'Rent price cannot be more than sale price'
                }
            }
        },
        updatePricePerSqm() {
            if (this.form.sqm > 0) {
                if (Number(this.form.sale_price) > 0) {
                    this.priceSaleSqm = Math.round(this.form.sale_price / this.form.sqm)
                }

                if (Number(this.form.rent_price) > 0) {
                    this.priceRentSqm = Math.round(this.form.rent_price / this.form.sqm)
                }
            }
        },
        formatSaleNumber() {
            if (!this.form.sale_price || !this.form.land_area) return ''

            const calAreaAndPrice = Math.round(this.form.sale_price / this.form.land_area)
            return calAreaAndPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        formatRentNumber() {
            if (!this.form.rent_price || !this.form.land_area) return ''

            const calAreaAndPrice = Math.round(this.form.rent_price / this.form.land_area)
            return calAreaAndPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
    }
}
</script>

<style scoped>
.owner-label {
  font-size: 1rem;
}
</style>